module.exports = __webpack_public_path__ + "static/media/kill-heel.8104b0e3.md";